export default {"src":"/_next/static/media/26-icon.dc6d6144.svg","height":46,"width":35,"blurWidth":0,"blurHeight":0};